module.exports = __webpack_public_path__ + "img/bg_resize_fg_grass_3.ea9f79d1.png";